/* eslint-disable react/prop-types */
import {React} from "react";
import   "../pages/styles.css";


export default function ImageText(props) {
    const selImage =props.selImage;
    const myText = props.myText.split("|");

     return (
          <div className="container" style={{display:"flex",alignItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px", width:"auto", margin:"auto"}}>
               
               <div className="container" style={{display:"grid",alignItems:"start",padding:"20px"}} >
                    {myText.map(function(data){
                              if(data){
                                   return (
                                        <div key={data.id} className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"left",background:'#eceff3f6'}}>{data}</div>
                                   )
                              }else{
                                   return(
                                        <div key={data.id} >{" "}</div>
                                   )
                              }
                              }
                         )
                    }
               </div>
               <img src={selImage} style={{display:"flex",alignItems:"center",background:'#eceff3f6',padding:"20px"}}/>
          </div>
     )
}